import type { Reducer } from 'redux';
import ErrorRecord from '~/data/ErrorRecord';
import type { MachineFilterV2Actions } from './actions';
import MachineFilterV2Constants from './constants';
import MachineFilterStateRecord from './reducer/MachineFilterStateRecord';

function getInitialState() {
  return new MachineFilterStateRecord();
}

const defaultState = getInitialState();

export const reducer: Reducer<MachineFilterStateRecord, MachineFilterV2Actions> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case MachineFilterV2Constants.ADD_FILTER_VALUE:
      return state.addFilterValue(action.filterDefinition, action.filterValue);

    case MachineFilterV2Constants.REMOVE_FILTER_VALUE:
      return state.removeFilterValue(action.filterName, action.filterValue);

    case MachineFilterV2Constants.CLEAR_FILTER_VALUES_BY_NAME:
      return state.clearFilterValuesByName(action.filterName);

    case MachineFilterV2Constants.CLEAR_ALL_FILTER_VALUES:
      return state.clearAllFilterValues();

    case MachineFilterV2Constants.SET_FILTER_VALUES:
      return state.setFilters(action.filters);

    case MachineFilterV2Constants.GET_FILTER_DEFINITIONS_REQUEST:
      return state.merge({
        isLoading: true,
        error: undefined,
      });

    case MachineFilterV2Constants.GET_FILTER_DEFINITIONS_REQUEST_SUCCESS:
      return state
        .merge({
          isLoading: false,
        })
        .setFilterSections(action.response.filterSections);

    case MachineFilterV2Constants.GET_FILTER_DEFINITIONS_REQUEST_ERROR:
      return state.merge({
        isLoading: false,
        error: new ErrorRecord(action.error),
      });

    case MachineFilterV2Constants.GET_SAVED_FILTERS_REQUEST:
      return state.merge({
        isLoadingSavedFilters: true,
        savedFiltersError: undefined,
      });

    case MachineFilterV2Constants.GET_SAVED_FILTERS_REQUEST_SUCCESS:
      return state
        .merge({
          isLoadingSavedFilters: false,
        })
        .setSavedFilters(action.response);

    case MachineFilterV2Constants.GET_SAVED_FILTERS_REQUEST_ERROR:
      return state.merge({
        isLoadingSavedFilters: false,
        savedFiltersError: new ErrorRecord(action.error),
      });

    case MachineFilterV2Constants.EDIT_SAVED_FILTER_REQUEST:
      return state
        .merge({
          isSavingFilter: true,
          saveFilterError: undefined,
        })
        .setSavedFilterIsLoading(action.payload.filterId, true);

    case MachineFilterV2Constants.SAVE_NEW_FILTER_REQUEST:
      return state.merge({
        isSavingFilter: true,
        saveFilterError: undefined,
      });

    case MachineFilterV2Constants.EDIT_SAVED_FILTER_REQUEST_SUCCESS:
      return state
        .merge({
          isSavingFilter: false,
        })
        .setSavedFilterIsLoading(action.payload.filterId, false)
        .setSavedFilterIsFavorite(action.payload.filterId, action.payload.favorite);

    case MachineFilterV2Constants.SAVE_NEW_FILTER_REQUEST_SUCCESS:
      return state.merge({
        isSavingFilter: false,
      });

    case MachineFilterV2Constants.EDIT_SAVED_FILTER_REQUEST_ERROR:
      return state
        .merge({
          isSavingFilter: false,
          saveFilterError: new ErrorRecord(action.error),
        })
        .setSavedFilterIsLoading(action.payload.filterId, false);

    case MachineFilterV2Constants.SAVE_NEW_FILTER_REQUEST_ERROR:
      return state.merge({
        isSavingFilter: false,
        saveFilterError: new ErrorRecord(action.error),
      });

    case MachineFilterV2Constants.APPLY_SAVED_FILTER:
      return state.applySavedFilter(action.savedFilter);

    case MachineFilterV2Constants.REMOVE_SAVED_FILTER_REQUEST:
      return state.setSavedFilterIsLoading(action.payload.filterId, true);

    case MachineFilterV2Constants.REMOVE_SAVED_FILTER_REQUEST_SUCCESS:
      return state.removeSavedFilter(action.payload.filterId);

    case MachineFilterV2Constants.REMOVE_SAVED_FILTER_REQUEST_ERROR:
      return state.setSavedFilterIsLoading(action.payload.filterId, false);

    case MachineFilterV2Constants.SET_VISIBILITY_FILTER:
      return state.setVisibilityFilter(action.assetIds);

    case MachineFilterV2Constants.CLEAR_VISIBILITY_FILTER:
      return state.clearVisibilityFilter();

    default:
      return state;
  }
};

export default reducer;
